module.exports = __webpack_public_path__ + "static/media/LeftArrowWhite.82c0cc21.svg";